import { useState } from "react";

interface Props {
  placeholder?: string;
  onAdd: (title: string) => void;
  busy?: boolean;
}

export function QuickAdd({
  placeholder = "Ajouter une tâche…",
  onAdd,
  busy,
}: Props) {
  const [text, setText] = useState("");

  const submit = () => {
    const title = text.trim();
    if (!title || busy) return;
    onAdd(title);
    setText("");
  };

  return (
    <div className="quick-add">
      <span style={{ color: "var(--ink-ghost)", fontSize: 15, lineHeight: 1 }}>
        ＋
      </span>
      <input
        value={text}
        placeholder={placeholder}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && submit()}
        aria-label="Nouvelle tâche"
      />
      {text.trim() && (
        <button className="btn primary" onClick={submit} disabled={busy}>
          Ajouter
        </button>
      )}
    </div>
  );
}
